module.exports = __webpack_public_path__ + "media/packs/site/assets/images/combook_binding/cover_front_bg_month_pastel-d943cb681095eb21557bc08d1f7c2b84.png";